module.exports = __webpack_public_path__ + "static/img/er.5ff3c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/er.jpg
// module id = qz7Y
// module chunks = 1